import _ from 'lodash';
import Layout from "@/layout/Layout";
import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router";
import HomePagePanel from "@/components/homePage/HomePagePanel";
import MButton from "@/components/atom/MButton";
import globalStyle from '@/styles/Global.scss'
import {getPhotos} from "@/api/photo";

const HomePage = () => {
  const history = useHistory()
  const [photos, setPhotos] = useState([])
  const [canEdit, setCanEdit] = useState(false)
  const {id} = useParams()

  useEffect(() => {
    (async () => {
      const photos = await getPhotos()
      setPhotos(photos)
      setCanEdit(!id)
    })()
  }, [id])

  const toEdit = () => {
    history.push(`/homePage/edit`)
  }

  const toAddHomePagePanel = () => {
    history.push(`/homePage/add`)
  }

  const goBack = () => {
    if (id) {
      history.push(`/uketori/${id}`)
    } else {
      history.push(`/setting`)
    }
  }

  return (<>
    <Layout title={'ホームページ'}>
      <div>
        {
          _.map(photos, (p) => {
            return (
              <React.Fragment key={p.id}>
                <div className={globalStyle.attribute}>
                  {
                    canEdit && <>
                      <MButton image={'tsuika.png'} value={'追加'} onClick={toAddHomePagePanel}></MButton>
                      <MButton image={'edit.png'} value={'編集'} onClick={toEdit}></MButton>
                    </>
                  }
                  <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
                </div>
                <HomePagePanel photo={p}></HomePagePanel>
                <hr className={globalStyle.separator} />
              </React.Fragment>
            )
          })
        }
      </div>
      <div className={globalStyle.attribute}>
        {
          canEdit && <>
            <MButton image={'tsuika.png'} value={'追加'} onClick={toAddHomePagePanel}></MButton>
            <MButton image={'edit.png'} value={'編集'} onClick={toEdit}></MButton>
          </>
        }
        <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
      </div>
    </Layout>
  </>)
}

export default HomePage
